import { buildProperty, type MapProperty, type StringProperty } from "@firecms/core";

import { LOCALE_ORDER, LocaleName, type Locale, type LocalizedString } from "./constants";
import { LocalizedStringField } from "./localizedStringField";
import { LocalizedStringPreview } from "./localizedStringPreview";

/** Mismo contrato que `buildProperty` para `dataType: "string"`. */
export type LocalizedStringPropertyInput = StringProperty;

function localeSubProperties(
  config: Omit<StringProperty, "name" | "dataType" | "Field" | "Preview">
) {
  const { validation, description: _description, ...rest } = config;
  const childValidation = validation
    ? { ...validation, required: false as const, requiredMessage: undefined }
    : undefined;

  return LOCALE_ORDER.reduce(
    (properties, locale) => {
      properties[locale] = buildProperty({
        ...rest,
        ...(childValidation ? { validation: childValidation } : {}),
        name: LocaleName[locale],
        dataType: "string",
      });
      return properties;
    },
    {} as Record<Locale, StringProperty>
  );
}

export function buildLocalizedStringProperty(property: StringProperty) {
  const { name, dataType: _dataType, Field, Preview, validation, ...stringConfig } =
    property;

  const mapValidation =
    validation?.required === true
      ? {
          ...validation,
          required: true as const,
          requiredMessage:
            validation.requiredMessage ?? "At least one translation is required",
        }
      : validation;

  return buildProperty({
    ...property,
    name,
    dataType: "map",
    validation: mapValidation,
    properties: localeSubProperties({ ...stringConfig, validation }),
    Field: LocalizedStringField,
    Preview: LocalizedStringPreview,
    customProps: property,
  } as MapProperty<LocalizedString>);
}
